import angular from 'angular';

export default class BasePicker {

    constructor ($element) {
        this.enabled = false;
        this.placeholder = this.placeholder || 'Type to search ...';
        this.watcher = null;
        this.$element = $element || null;
    }

    refresh (search) {
        let self = this;
        this.store.params.search = search;
        if (!search && !this.enabled) { return; }

        this.store.refresh().then(function(){
            if (search === '') {
                self._push(self.ngModel);
            }
        });
    }

    _push (obj) {
        if (angular.isUndefined(obj) || obj === null) {  return ; }
        let self = this;
        let i = self.store.list.findIndex(p => p.id === obj.id);
        if (i >= 0) {
            self.store.list.splice(i, 1);
        }
        self.store.list.unshift(obj);
    }

    onClick () {
        if (this.enabled) { return; }
        this.enabled = true;
        this.refresh('');
    }

    onSelect ($item, $model) {
        let self = this;
        self._push($model);
    }

    $onDestroy () {
        if (this.watcher) {
            this.watcher();
            this.watcher = null;
        }
        if (this.store && this.store.list) {
            self.store = null;
        }

        if (this.$element) {
            this.$element.remove();
            this.$element = null;
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/directives/base.picker.js